export default __webpack_public_path__ + "static/ShareSection2_it-5394aacea460e3390ff36d5332f99621.png";